import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Marraine } from "@/components/Marraine";
import { Timeline } from "@/components/Timeline";
import { LiveBroadcast } from "@/components/LiveBroadcast";
import { PreinscriptionForm } from "@/components/PreinscriptionForm";
import { CandidatsSection } from "@/components/CandidatsSection";
import { Footer } from "@/components/Footer";

export default function Landing() {
  return (
    <div className="grain relative bg-theatre-ink" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Marraine />
        <Timeline />
        <LiveBroadcast />
        <PreinscriptionForm />
        <CandidatsSection />
      </main>
      <Footer />
    </div>
  );
}
